import { Controller } from "@hotwired/stimulus";

// Rewires the "Gérer ce rattachement" modal whenever it's opened from a
// trigger on the parcours-pro card. The trigger declares the link id and a
// few labels via data-* attributes; we read them through the global open
// event from cockpit_modal, but it's simpler to listen to clicks directly on
// triggers tagged with data-manage-employment-trigger.
export default class extends Controller {
  static targets = ["endForm", "detachForm", "name", "meta", "target"];

  connect() {
    this._handler = (e) => this._onTriggerClick(e);
    document.addEventListener("click", this._handler, true);
  }

  disconnect() {
    document.removeEventListener("click", this._handler, true);
  }

  _onTriggerClick(event) {
    const trigger = event.target.closest("[data-manage-employment-trigger]");
    if (!trigger) return;

    const url       = trigger.dataset.manageEmploymentUrl;
    const name      = trigger.dataset.manageEmploymentName || "";
    const poste     = trigger.dataset.manageEmploymentPoste || "";
    const principal = trigger.dataset.manageEmploymentPrincipal === "true";

    if (!url) return;

    // Repoint both forms at this specific entreprise_link.
    if (this.hasEndFormTarget)    this.endFormTarget.action    = url;
    if (this.hasDetachFormTarget) this.detachFormTarget.action = url;

    // Refresh the header so the user sees what they're acting on.
    if (this.hasNameTarget) this.nameTarget.textContent = name || "Entreprise";
    if (this.hasMetaTarget) {
      const bits = [];
      if (poste) bits.push(poste);
      bits.push(principal ? "rôle principal" : "rôle secondaire");
      this.metaTarget.textContent = bits.join(" · ");
    }
  }
}
